import apiFetch from '@wordpress/api-fetch';
import { onReady } from './utils.js';

onReady( () => {
	const post_id = window.post_id;
	if ( post_id === 0 ) {
		return;
	}

	const is_counted = sessionStorage.getItem( `mp_post_viewed_${post_id}` );
	if ( is_counted ) {
		return;
	}

	apiFetch( {
		path: `/mp/v1/posts/${post_id}/view`,
		method: 'POST',
	} ).then( () => {
		sessionStorage.setItem( `mp_post_viewed_${post_id}`, '1' );
	} );
} );
